<template>
  <div class="SubstationManagement">
    <div id="left">
      <div id="distributionchart">
        <Videoone></Videoone>
      </div>
      <div
        id="areachart"
        class="row-center"
        style=" justify-content: space-between;"
      >
        <div class="EchartsLeft">
          <div class="title">今日能耗趋势</div>
          <div class="tab">
            <span :class="tabSdx == 0 ? 'tabSpan' : ''" @click="tabSdx = 0"
              >电</span
            >
            <span :class="tabSdx == 1 ? 'tabSpan' : ''" @click="tabSdx = 1"
              >水</span
            >
            <span :class="tabSdx == 2 ? 'tabSpan' : ''" @click="tabSdx = 2"
              >热</span
            >
            <span :class="tabSdx == 3 ? 'tabSpan' : ''" @click="tabSdx = 3"
              >冷</span
            >
          </div>
          <div class="tabCharts">
            <charts id="chartOption1" :option="chartOption1" v-if="!showOption1"></charts>
            <div class="nodata" v-else><img src="../../assets/img/not_found_data.png" alt=""></div>
          </div>
        </div>
        <div class="EchartsRight" v-loading="loadingChain">
          <div class="title">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                能耗环比·{{ downLabel
                }}<img src="../../assets/img/ardown.png" alt="" />
              </span>
              <el-dropdown-menu slot="dropdown" style="width:6vw">
                <el-dropdown-item v-for="item in downlist" :command="item">{{
                  item.label
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="tab">
            <span :class="tabSdx == 0 ? 'tabSpan' : ''" @click="tabSdx = 0"
              >电</span
            >
            <span :class="tabSdx == 1 ? 'tabSpan' : ''" @click="tabSdx = 1"
              >水</span
            >
            <span :class="tabSdx == 2 ? 'tabSpan' : ''" @click="tabSdx = 2"
              >热</span
            >
            <span :class="tabSdx == 3 ? 'tabSpan' : ''" @click="tabSdx = 3"
              >冷</span
            >
          </div>
          <div class="tabCharts" v-if="!showOption2">
            <div class="chartname" >
              环比增长：{{normal}}%<img src="../../assets/img/up.png" v-if="normal>0"/><img src="../../assets/img/down.png" v-else/>
            </div>
            <div style="height:21vh;width:100%" ><charts id="chartOption2" :option="chartOption2"></charts></div>
          </div>
          <div class="tabCharts" v-else>
            <div class="nodata" ><img src="../../assets/img/not_found_data.png" alt=""></div>
          </div>
        </div>
      </div>
    </div>
    <div class="rightYuanqu">
      <div class="top">
        <div class="title">
          <img :src="$store.state.project.projectInfo.projectIcon" alt="" />
          <div class="titler">
            <div class="titleName">
              {{$store.state.project.projectInfo.buildingName}}
              <Garden :ProJectInfo="ProJectInfo"/>
            </div>
          </div>
        </div>

        <div class="area row-center">
          <div class="item">
            <div class="name">今日总能耗（折标煤）</div>
            <div class="num">{{energyInfo.total}} <span>tce</span></div>
          </div>
          <div class="item">
            <div class="name">较昨日</div>
            <div class="num " :class="quite>0?'red':'green'">
              {{quite}} <span>tce</span
              ><img src="../../assets/img/up.png" alt="" height="12" v-if="quite>0"/><img src="../../assets/img/down.png" alt="" height="12" v-else/>
            </div>
          </div>
        </div>
      </div>
      <div class="today">
        <div class="today-title">能耗占比</div>
        <div class="tab">
          <span
            :class="energyIndex == 0 ? 'tabSpan' : ''"
            @click="energyIndex = 0"
            >年</span
          >
          <span
            :class="energyIndex == 1 ? 'tabSpan' : ''"
            @click="energyIndex = 1"
            >月</span
          >
          <span
            :class="energyIndex == 2 ? 'tabSpan' : ''"
            @click="energyIndex = 2"
            >周</span
          >
          <span
            :class="energyIndex == 3 ? 'tabSpan' : ''"
            @click="energyIndex = 3"
            >日</span
          >
        </div>
        <div style="height:22vh;width:100%;">
          <charts id="chartOption4" :option="chartOption4"></charts>
          <!-- <div id="today_echarts" style="height:100%;width:100%;"></div> -->
        </div>
        <div class="energyused">
          <span>用电量：{{Number(energyRatio.energy).toFixed(2)}}kWh</span>
          <span>用热量：{{Number(energyRatio.heat).toFixed(2)}}GJ</span>
          <span>用水量：{{Number(energyRatio.water).toFixed(2)}}m³</span>
          <span>用冷量：{{Number(energyRatio.cooling).toFixed(2)}}GJ</span>
        </div>
      </div>
      <div class="statistics EchartsRight" v-loading="loading">
        <div class="title">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              能耗排名·{{ downLabel
              }}<img src="../../assets/img/ardown.png" alt="" />
            </span>
            <el-dropdown-menu slot="dropdown" style="width:6vw">
              <el-dropdown-item v-for="item in downlist" :command="item">{{
                item.label
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="tab">
          <span :class="tabSdx == 0 ? 'tabSpan' : ''" @click="tabSdx = 0"
            >电</span
          >
          <span :class="tabSdx == 1 ? 'tabSpan' : ''" @click="tabSdx = 1"
            >水</span
          >
          <span :class="tabSdx == 2 ? 'tabSpan' : ''" @click="tabSdx = 2"
            >热</span
          >
          <span :class="tabSdx == 3 ? 'tabSpan' : ''" @click="tabSdx = 3"
            >冷</span
          >
        </div>
        <div class="energy" >
          <ul  v-if="EnergyListShow&&node!='water'">
            <li v-for="(item, index) in EnergyList" :key="index">
              <div class="name" :title="item.building.name">
                {{ index + 1 }}.{{ item.building.name }}
              </div>
              :&nbsp;&nbsp;&nbsp;{{ item.power[node=='electricity'?'power':node].toFixed(2) }}kWh
            </li>
          </ul>
            <div class="nodata" v-else-if="node=='water'"><p>未分楼层计量</p><img src="../../assets/img/not_found_data1.png" alt=""></div>
            <div class="nodata" v-else><img src="../../assets/img/not_found_data.png" alt=""></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Videoone from "./components/videoone";
const Href = () => import("./components/href.vue");
const TodayEvent = () => import("./components/newComponts/todayEvent.vue");
const Garden = () => import("./components/garden.vue");
import charts from "../../components/Energy/charts";
import {
  dateFormat,
} from "../../util/DateUtil";
import {
  getTodayTime,
} from "../../util/date";
import { 
ConsumptionTotal,
ConsumptionOfProject,
ConsumptionProportionSC,
buildingRankings,
ProjectCompareClassifiedPower } from "../../api/power";
let imgbg = require("../../assets/img/water.png")
export default {
  name: "SubstationManagement",
  data() {
    return {
      tabSdx: 0,
      energyIndex: 1,
      temp: [],
      power: {
        today: [],
        yesterday: [],
      },
      todayData: [],
      chartOption2Data: [],
      looplist: [],
      downLabel: "月",
      downValue: "MONTH",
      node:"electricity",
      unit:"kWh",
      downlist: [
        {
          label: "日",
          value: "DAY",
        },
        {
          label: "周",
          value: "WEEK",
        },
        {
          label: "月",
          value: "MONTH",
        },
        {
          label: "年",
          value: "YEAR",
        },
      ],
      energyInfo:{},
      quite:0, //较昨日
      energyRatio:{}, //能耗占比
      loading:false,
      ProJectInfo:{},
      showOption1:false,
      showOption2:false,
      EnergyListShow:true,
      loadingChain:false
    };
  },

  components: {
    Videoone,
    Href,
    TodayEvent,
    Garden,
    charts,
  },
  computed: {
    //路由名称
    routeName() {
      return this.$route.query.name;
    },
    EnergyList() {
        return this.looplist;
    },
    
    chartOption1() {
      return {
        grid: {
          left: "0%",
          right: "3%",
          bottom: "4%",
          top: "15%",
          containLabel: true,
        },
        legend: {
          x: "center", //可设定图例在左、右、居中
          itemHeight: 14,
          itemWidth: 14,
          itemGap: 30,
          textStyle: {
            fontSize: "16rem", //字体大小
          },
          data: [
            {
              name: "今日",
              icon: "rect",
            },
            {
              name: "昨日",
              icon: "rect",
            },
          ],
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.temp,
        },
        yAxis: {
          type: "value",
          nameTextStyle: {
            align: "left",
            padding: [0, 0, 0, 24],
            fontSize: 16,
            color: "#333",
          },
        },
        series: [
          {
            data: this.power.yesterday,
            type: "line",
            name: "昨日",
            smooth: true,
            itemStyle: {
              color: "rgba(93, 112, 146, 1)",
            },
            areaStyle: {
              color: "rgba(93, 112, 146, 0.3)"
            },
          },
          {
            name: "今日",
            data: this.power.today,
            type: "line",
            smooth: true,
            itemStyle: {
              color: "#0D94FF",
            },
            areaStyle: {
              color: "rgba(13, 148, 255, 0.3)"
            },
          },
        ],
      };
    },
    chartOption2() {
      let title = [];
      if (this.downValue == "DAY") {
        title = ["本期                            上期"];
      } else if (this.downValue == "WEEK") {
        title = ["本周                            上周"];
      }else if (this.downValue == "MONTH") {
        title = ["本月                            上月"];
      } else {
        title = ["本年                            去年"];
      }
      return {
        tooltip: {
          formatter: "{a} {c} ("+this.unit+")", 
        },
        grid: {
          left: "2%",
          right: "0%",
          bottom: "15%",
          top: "10%",
          containLabel: true,
        },

        calculable: true,
        xAxis: [
          {
            show: true,
            name: title,
            nameLocation: "middle",
            type: "category",
          },
        ],
        // 边界值
        yAxis: [
          {
            type: "value",
            scale: true,
            min: 0,
            splitNumber: 5,
            type: "value",
          },
        ],
        series: this.chartOption2Data,
      };
    },
    chartOption4() {
      return {
        color: ["#0D94FF","#F6BD16", "#E8684A", "#9270CA", "#6DC8EC"],
        tooltip: {
          trigger: "item",
          formatter:'{c0}tce'

        },
        graphic: {
          //图形中间文字
          type: "image",
          left: "center",
          top: "center",
          style: {
            image: imgbg,
            width: 28,
            height: 40,

          },
        },
        series: [
          {
            type: "pie",
            radius: ["45%", "65%"],
            label: {
              formatter: "{name|{b}}: {time|{d}%}",
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 25,
              fontSize: "16rem",
              fontWeight: 800,
              rich: {
                time: {
                  fontSize: "16rem",
                  // color: "#0D94FF"
                },
                name: {
                  fontSize: "16rem",
                  // color: "#0D94FF"
                },
              },
            },
            itemStyle: {
              // 此配置
              normal: {
                borderWidth: 2,
                borderColor: "#ffffff",
              },
            },
            labelLine: {
              show: true,
              lineStyle: {
                width: 2,
              },
            },
            data: this.todayData,
          },
        ],
      };
    },
    selectLable() {
      return this.downlist.filter((item, index) => item === this.downLabel)[0]
        .label;
    },
    normal(){
      if(this.chartOption2Data.length>0){
        if(this.chartOption2Data[1].data[0]==0){
          return 100
        }else{
           return ((Number(this.chartOption2Data[0].data[0]) - Number(this.chartOption2Data[1].data[0])) / Number(this.chartOption2Data[1].data[0])*100).toFixed(2)
        }
       
      }else{
        return 0
      }
      
    }
  },
  watch: {
    downLabel() {
      this.GetCompareChain();
      this.getLooplist();
    },
    energyIndex(){
      this.Getproportion(); 
    },
    tabSdx(){
      this.node = this.getnode()
      this.GetCompareChain();
      this.getLooplist();
      this.GetConsumptionOfProject();
    },
    node(n,o){
      if(n=='electricity'){
        this.unit = 'kWh'
      }else if(n=='water'){
        this.unit = 'm³'
      }else{
        this.unit = 'GJ'
      }
    }
  },
  created() {
    //项目所有 区域
    this.$store.dispatch("HomePage/actionsAllAreas");
  },
  mounted() {
    this.$store.commit("Dthere", 1);
    for (let i = 0; i <= 24; i++) {
      this.temp.push(i + "点");
    }
    this.getLooplist();
    this.Getproportion(); 
    this.GetConsumptionTotal();
    this.GetConsumptionOfProject();
    this.GetCompareChain();
  },
  methods: {
    //环比
    async GetCompareChain(){
      this.loadingChain = true
      this.chartOption2Data = []
      let obj ={
         projectId:this.$store.state.project.currentProject.projectId,
         compareType:"ALTERNATE",
         date:dateFormat("YY-mm-dd",new Date())+'T00:00:00Z',
         dateRange:this.downValue,
         powerType:this.node.toUpperCase(),
      }
      let response = await ProjectCompareClassifiedPower(obj);
      let data = response.data.data.data[0]
      let title = []; 
      if (this.downValue == "DAY") {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
        title = ["本期", "上期"];
      } else if (this.downValue == "WEEK") {
        title = ["本周", "上周"];
      }else if (this.downValue == "MONTH") {
        title = ["本月", "上月"];
      } else {
        title = ["本年", "去年"];
      }
      this.chartOption2Data = [
          {
            name: title[0],
            type: "bar",
            data: [Number(data[1]).toFixed(2)],
            // barGap: "10%",
            barWidth: 110, //柱图宽度
            itemStyle: {
              normal: {
                color: "#5B8FF9",
              },
            },
          },
          {
            name: title[1],
            type: "bar",
            data: [Number(data[0]).toFixed(2)],
            // barleft: 200,
            barGap: "10%",
            barWidth: 110, //柱图宽度
            itemStyle: {
              normal: {
                color: "#5AD8A6",
              },
            },
          },
        ];
        
      this.loadingChain = false
      if(data.filter(e=>e!=0).length>0){
        this.showOption2 = false
      }else{
        this.showOption2 = true
        return
      }
    },
    getnode(){
      switch (this.tabSdx) {
        case 0:
          return "electricity"
          break;
        case 1:
          return "water"
          break;
        case 2:
          return "heat"
          break;
        case 3:
          return "cooling"
          break;
      }
    },
    //今日能耗趋势
    async GetConsumptionOfProject(){
      
      let time = getTodayTime()
      let list = [time.yesterday,time.today]
      list.forEach(async (element,index) => {
        let obj = {
          date:`${element}T00:00:00Z`,
          powerType:this.node.toUpperCase(),
          projectId:this.$store.state.project.currentProject.projectId,
          range:"DAY"
        }
        let response = await ConsumptionOfProject(obj);
        if(index==0){
          this.power.yesterday = response.data.data.result[this.node].map(e=>e!=null?e.toFixed(2):'')
        }else{
          this.power.today = response.data.data.result[this.node].map(e=>e!=null?e.toFixed(2):'')
        }
        if(this.power.yesterday.filter((e) => e != null&&e!="").length<=0&&this.power.today.filter((e) => e != null&&e!="").length<=0){
          this.showOption1 = true
        }else{
          this.showOption1 = false
        }
      });
    },
    async GetConsumptionTotal(){
        let response = await ConsumptionTotal();
        this.energyInfo = response.data.data.energyConsumption;
        this.energyInfo.total = this.energyInfo.total.toFixed(2)
        this.quite = (this.energyInfo.total-this.energyInfo.lastTotal).toFixed(2)
    },
    Getenergy(){
      switch (this.energyIndex) {
        case 0:
          return "YEAR"
          break;
        case 1:
          return "MONTH"
          break;
        case 2:
          return "WEEK"
          break;
        case 3:
          return "DAY"
          break;
        default:
          break;
      }
    },
    //能耗占比
    async Getproportion(){
      let obj = {
        projectId:this.$store.state.project.currentProject.projectId,
        dateRange:this.Getenergy()
      }
        let response = await ConsumptionProportionSC(obj);
        let data = response.data.data.proportion;
        this.energyRatio = data
       this.todayData = [
        { value: data.energySC.toFixed(2), name: "电", label: { color: "#0D94FF" } },
        // { value: data.heatSC.toFixed(2), name: "热", label: { color: "#E8684A" } },
        { value: data.waterSC.toFixed(2), name: "水", label: { color: "#6DC8EC" } },
        // { value: data.coolingSC.toFixed(2), name: "冷", label: { color: "#9270CA" } },
      ];
    },
    handleCommand(command) {
      this.downLabel = command.label;
      this.downValue = command.value;
    },
    //能耗排名
    async getLooplist() {
      this.loading = true
      // let obj = {
      //   current:"",
      //   dateRange:this.downValue,
      //   paramId:this.$store.state.project.currentProject.projectId,
      //   paramType:"PROJECT_ID"
      // }
      // let response = await GetPowerRanking(obj);
      
      if(this.tabSdx==0){
        let obj = {
          powerType:this.node.toUpperCase(),
          projectId:this.$store.state.project.currentProject.projectId,
          date:dateFormat("YY-mm-dd",new Date())+'T00:00:00Z',
          dateRange:this.downValue.toUpperCase()
        }
        let response = await buildingRankings(obj);
        this.EnergyListShow = true
        this.looplist = response.data.data.list.slice(0, 5) || [];
      }else{
        this.EnergyListShow = false
        this.looplist = [];
      }
      this.loading = false
    },
  },
};
</script>
<style scoped lang="less">
.nodata{
  text-align: center;
  padding-top: 20px;
  img{
    height: 200rem;
  }
}
.el-dropdown-menu {
  text-align: center;
}
.energyused {
  text-align: center;
  span {
    display: inline-block;
    background: rgba(0, 43, 102, 0.04);
    border-radius: 4px;
    height: 4vh;
    width: 13vw;
    margin: 6rem;
    line-height: 4vh;
    text-align: center;
    font-size: 16rem;
    color: #666666;
  }
}
.energy {
  li {
    height: 4vh;
    line-height: 4vh;
    margin-top: 8rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    font-size: 18rem;
    overflow: hidden;
    .name {
      display: inline-block;
      max-width: 18vw;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: -11px;
      white-space: nowrap;
    }
    span {
      // margin-left: 45rem;
      font-weight: bold;
      font-size: 18rem;
      float: right;
      text-align: left;
      img {
        vertical-align: middle;
      }
    }
  }
}
#distributionchart {
  position: relative;
  z-index: 1;
}
.Category {
  height: 8vh;
  line-height: 8vh;
  text-align: center;
  font-size: 18rem;
  color: #666;
  // margin-top: 30rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  justify-content: space-between;
  padding: 0rem 30rem;
  .item {
    // width: 33%;
    span {
      font-size: 24rem;
      font-weight: bold;
      color: #0d94ff;
      margin-left: 13rem;
      vertical-align: -2px;
    }
  }
}
.statistics {
  height: 29.62vh;
  .name {
    text-align: center;
    font-size: 18rem;
  }
}
.EchartsLeft,
.EchartsRight {
  .w(528);
  background: #ffffff;
  // height: 100%;
  padding: 20rem 23rem;
  position: relative;
  .title {
    font-size: 18rem;
    font-weight: bold;
    margin-bottom: 10rem;
    span {
      font-size: 18rem;
      color: #333;
      float: left;
      cursor: pointer;
      img {
        vertical-align: middle;
        margin-left: 5px;
      }
    }
  }
}
.today {
  background: #ffffff;
  .h(400);
  margin-bottom: 8rem;
  position: relative;
  .today-title {
    font-size: 18rem;
    font-weight: bold;
    padding: 23rem 0 0 23rem;
  }
  .more {
    text-align: center;
    color: #999999;
    font-size: 14rem;
    line-height: 5vh;
    cursor: pointer;
    display: block;
    text-decoration: none;
  }
  .more:hover {
    color: #0d94ff;
  }
  .message {
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    background: rgba(0, 43, 102, 0.02);
    .h(200);
    .item {
      height: 48rem;
      font-size: 18rem;
      padding: 0 20rem;
      justify-content: end;
      img {
        width: 16px;
      }
      span {
        color: #999999;
        font-size: 14rem;
        width: 55px;
      }
      .name {
        color: #666666;
        width: 280rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 10rem;
        margin-right: 10rem;
      }
      .statue {
        width: 150rem;
        text-align: center;
      }
      .site {
        color: #999999;
      }
    }
    .item:nth-child(odd) {
      //偶数行
      background: rgba(0, 43, 102, 0.03);
    }
  }
}
.area {
  justify-content: flex-start;
  padding-top: 10rem;
  .item {
    width: 45%;
    text-align: left;
    .name {
      font-size: 18rem;
      // height: 30px;
    }
    .num {
      color: #0d94ff;
      font-size: 30rem;
      font-weight: bold;
    }
    .red {
      color: #fc2e32;
    }
    .green{
      color: #5ad8a6;
    }
    span {
      font-size: 18rem;
    }
    .online {
      color: #333;
      span {
        color: #68d86a;
      }
    }
  }
}
.rightYuanqu {
  .top {
    background-color: #fff;
    padding: 0 24rem;
    margin-bottom: 8rem;
    .h(232);
  }
}
</style>
